module.exports = __webpack_public_path__ + "static/media/LogoMRC.c96c014e.jpg";